/**
* @Author: zachalam
* @Date:   2017-03-13T16:47:12-07:00
* @Email:  zach@reflexmedia.com
* @Last modified by:   Daniel
* @Last modified time: 2017-03-17T11:48:32-07:00
*/

import React, { Component } from 'react';

import PlanCard from './PlanCard';
import Container from '../../blocks/Container';
import Panel from '../../common/Panel';
import Headline from '../../common/Headline';
import { css, StyleSheet } from 'aphrodite/no-important';
import { dimensions, box } from '../../../style';



class BillingSuccess extends Component {


  componentWillReceiveProps(nextProps) {
    // notify GTM of transaction complete
    if(this.props.payments != nextProps.payments) {
      let lastPayment = nextProps.payments[0];
      window.dataLayer.push({
       'transactionId': lastPayment.id,
       'transactionAffiliation': 'Credit Purchase',
       'transactionTotal': lastPayment.charge_amt,
       'event':	'transactionComplete'
      });
    }
  }
  render() {


    let lastPayment = this.props.payments[0];


    if(lastPayment)
    {
      let thePackage = lastPayment.package.data;

      return (
        <div>

        <Container screenTop>
          <Panel>
            <Headline>
              Thank you for your purchase!
            </Headline>
          </Panel>
          <h1 className="title-size3 pageHeader-title"></h1>
          <p className="pageHeader-description"> </p>
        </Container>

        <div className="container u-maxWidth640">
          <div className="">
            <div className="billing-tab MonthlyMembership-info">
              <ul className="ListStyle ListDisc">
                <li>{thePackage.description}</li>
              </ul>
            </div>
          </div>
        </div>


        </div>
      );
    } else {
      // no last payments..
      return (<div />);
    }
  }
}



export default BillingSuccess;



// WEBPACK FOOTER //
// ./src/components/pages/Billing/BillingSuccess.jsx